import * as actionTypes from "../actionTypes/actionTypes";


const initialState = {
    loggedInUserInfo:{
        userRole:null,
        userId:null,
        userName:null,
        isLoading:false,
        hasError:false
    }
}

export const appReducer = (state = initialState, action) => {
    const newState = { ...state };
    switch (action.type) {
        case actionTypes.FETCH_USER_ID_START:
            return{
                ...newState,
                loggedInUserInfo:{...newState.loggedInUserInfo, isLoading:true, hasError:false}
            }
        case actionTypes.FETCH_USER_ID_SUCCESS:
            return{
                ...newState,
                loggedInUserInfo:{...newState.loggedInUserInfo, userId:action.payload,isLoading:false,
                    hasError:false
                }
            }
        case actionTypes.FETCH_USER_ID_FAILURE:
            return{
                ...newState,
                loggedInUserInfo:{...newState.loggedInUserInfo, userId:action.payload,isLoading:false,
                    hasError:true
                }
            }    
        case actionTypes.FETCH_USER_ROLE_START:
            return{
                ...newState,
                loggedInUserInfo:{...newState.loggedInUserInfo, isLoading:true,hasError:false}
            }
        case actionTypes.FETCH_USER_ROLE_SUCCESS:
            return{
                ...newState,
                loggedInUserInfo:{...newState.loggedInUserInfo, userRole:action.payload.securityLevel,userId:action.payload.id,userName:action.payload.name, isLoading:false,
                hasError:false}
            }   
        case actionTypes.FETCH_USER_ROLE_FAILURE:
            return{
                ...newState,
                loggedInUserInfo:{...newState.loggedInUserInfo, userRole:action.payload,isLoading:false,
                    hasError:true
                }
            }    
        default:
            return{
                ...newState
            }     

    }
}